import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SUCCESS_MSG, ERROR_MSG } from '../../shared/errorMessages';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  @ViewChild('cform') profileFormDirective;
  profileForm: FormGroup;
  formErrors = {
    'name': '',
    'email': '',
    'phone': '',
    'username': ''
  };
  validationMessages = {
    'name': {
      'required': 'Por favor ingrese un nombre'
    },
    'email': {
      'email': 'Correo electrónico invalido'
    },
    'phone': {
      'pattern': 'Por favor ingrese un número telefónico válido'
    }
  };
  maxDate: Date;
  isLoading: boolean = false;
  user: User;
  image: string = '';
  tabNumber: number = 0;
  constructor(private fb: FormBuilder,
    private dialogRef: MatDialogRef<ProfileComponent>,
    private gralService: UserService, private _snackBar: MatSnackBar) {
    this.createForm();
  }

  ngOnInit(): void {
    this.profileForm.reset({
      name: this.user.name,
      email: this.user.email,
      phone: this.user.phone
    });
    this.image = this.user.avatar;
  }

  createForm() {
    this.profileForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      phone: ['', [Validators.pattern]]
    });

    this.profileForm.valueChanges
      .subscribe(data => this.onValueChanged(data));

    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.profileForm) { return; }
    const form = this.profileForm;
    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.formErrors[field] += messages[key] + ' ';
            }
          }
        }
      }
    }
  }

  save() {
    let user = this.profileForm.value;
    this.user.phone = user.phone ? user.phone.toString() : this.user.phone;
    this.user.name = user.name ? user.name : this.user.name;
    this.user.editMyself = true;
    this.user.avatar = this.image;

    this.gralService.createUpdateUser(this.user).then(res => {
      if (res.success) {
        let user = this.profileForm.value;
        user.objectId = res.data.id;
        this._snackBar.open(SUCCESS_MSG['SUCCESS_UPDATED'], null, {
          duration: 3000,
        });
        this.dialogRef.close(user);
      } else {
        this._snackBar.open(res.data, null, {
          duration: 3000,
        });
      }
    }).catch(error => {
      this._snackBar.open(ERROR_MSG[error.code], null, {
        duration: 3000,
      });
    });
  }

  saveImage($event) {
    this.isLoading = true;
    const files = $event.target.files[0];
    if (files) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(files);
      fileReader.onload = () => {
        this.gralService.addImageFirebase($event.target.files[0].name, fileReader.result).then(res => {
          this.isLoading = false;
          if (res.success) {
            this.image = res.data;
            this._snackBar.open(SUCCESS_MSG['SUCCESS'], null, {
              duration: 3000,
            });
          } else {
            this._snackBar.open(res.data, null, {
              duration: 3000,
            });
          }
        }).catch((error) => {
          this.isLoading = false;
          this._snackBar.open(ERROR_MSG[error.code], null, {
            duration: 3000,
          });
        });
      };

    }
  }
}
